export const theoneActivity = {
    videoDialog: function (data, closeDialogCallBack, lookOverCallBack, noVideoCallBack, jumpVideoCallBack) {
        //弹窗视频
        // data-弹窗展示数据
        // closeDialogCallBack-关闭弹窗回调
        // lookOverCallBack-看视频结束回调
        // noVideoCallBack-不看视频回调
        // jumpVideoCallBack-跳出视频回调
        window.TheoneActivity.videoDialog(JSON.stringify(data), closeDialogCallBack, lookOverCallBack, noVideoCallBack, jumpVideoCallBack)
    },

    watchVideo: function (data, lookOverCallBack, jumpVideoCallBack) {
        // data-弹窗展示数据
        // lookOverCallBack-看视频结束回调
        // jumpVideoCallBack-跳出视频回调
        window.TheoneActivity.watchVideo(JSON.stringify(data), lookOverCallBack, jumpVideoCallBack)//纯看视频
    },

}


// WEBPACK FOOTER //
// ./src/plugin/theone/theoneActivity.js